// src/config/index.ts

import { isTablet } from 'react-device-detect'

export const WEB_URL = 'https://mrlove.realitygame.com.tw'
// export const WEB_URL = 'https://test-qmriver.netlify.app'

const width = window.innerWidth
const height = window.innerHeight

export let ws = 0
export let dw = 0
// dw = extra screen width
export let dh = 0
// dh = extra screen height

export let wss = 0
export let dww = 0
export let dhh = 0

if (width >= (height * 3) / 4 || isTablet) {
  // 寬螢幕
  ws = height / 640
  wss = ws / 2
  dw = width - (height / 16) * 9 > 0 ? width - (height / 16) * 9 : 0
  dww = dw / 2
} else {
  // 長螢幕
  ws = width / 360
  wss = ws / 2
  dh = height - (width / 9) * 16 > 0 ? height - (width / 9) * 16 : 0
  dhh = dh / 2
}

// return [ws, wss, dw, dww, dh, dhh]
